import { Box, Paragraph } from '@base-app';
import { styled } from '@/stitches.config';
import { CSS } from '@stitches/react';

export const cardGridStyles: CSS = {
  marginBottom: '$6',
  width: '100%',
};

export const StyledFormSectionContainer = styled(Box, {
  padding: '$2 $8 $2 $8',
});

export const StyledFormFieldsContainer = styled(Box, {
  display: 'flex',
  flexDirection: 'column',
  '@sm': {
    flexDirection: 'row',
  },
});

export const StyledParagraph = styled(Paragraph, {
  marginBottom: '$4',
});

export const leftFormFieldStyles: CSS = {
  width: '100%',
  '@sm': {
    paddingRight: '$3',
    width: '50%',
  },
};

export const rightFormFieldStyles: CSS = {
  width: '100%',
  '@sm': {
    paddingLeft: '$3',
    width: '50%',
  },
};

export const rowFormFieldStyles: CSS = {
  width: '100%',
  justifySelf: 'flex-start',
  display: 'block',
};

export const columnFormFieldStyles: CSS = {
  width: '100%',
  flexDirection: 'column',
};

export const withdrawalLabelStyles: CSS = {
  fontSize: '$sm',
  color: '$charcoal500',
  textAlign: 'left',
};

export const cardLabelStyles: CSS = {
  fontSize: '$sm',
  textAlign: 'left',
};

export const cardBoldLabelStyles: CSS = {
  fontSize: '$sm',
  textAlign: 'left',
  textDecorationLine: 'underline',
  fontWeight: 'bold',
};

export const submitButtonStyles: CSS = {
  margin: 'auto',
  marginTop: '$4',
};
